<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";

const isWx = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
let map = null;
const txt = `快来【足迹猫APP】\n随时随地查看我的位置信息\n一起守护彼此安全`
const popShow = ref(false);
const openPop = () => {
  popShow.value = true
  console.log('open clicked')
}

const closePop = () => {
  popShow.value = false
  console.log('close clicked')
}

const downloadClick = () => {
  console.log('download clicked')

  const isApple = navigator.userAgent.toLowerCase().indexOf('iphone') !== -1
  if (isApple) {
    window.location.href = 'https://apps.apple.com/cn/app/%E8%B6%B3%E8%BF%B9%E7%8C%AB/id6752314515'
  }
}

const openAppClick = () => {
  console.log('openApp clicked')
  if (isWx) {
    alert('请点击右上角，在浏览器中打开此页面')
    return
  }

  window.location.href = 'heluozjm://zjm.ppjjpujie.com/app'
  const isApple = navigator.userAgent.toLowerCase().indexOf('iphone') !== -1

  setTimeout(() => {
    if (isApple) {
      window.location.href = 'https://apps.apple.com/cn/app/%E8%B6%B3%E8%BF%B9%E7%8C%AB/id6752314515'
    }
  }, 3000)
}

onMounted(() => {
  const params = new URL(location.href).searchParams
  const lng = params.get('lng') || '116.397474'
  const lat = params.get('lat') || '39.90853'
  const content = '<img style="width: 90px" src="' + require('../assets/map_poi.png') + '" alt="poi" />'
  AMapLoader.load({
    key: "8f5dc4f6350d94fa29db871e5ac31a70", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  })
    .then((AMap) => {
      const position = new AMap.LngLat(lng, lat)
      const marker = new AMap.Marker({
        position: position,
        content: content,
      })
      map = new AMap.Map("container", {
        // 设置地图容器id
        viewMode: "3D", // 是否为3D地图模式
        zoom: 11, // 初始化地图级别
        center: [lng * 1.00028, lat * .997], // 初始化地图中心点位置
        offset: new AMap.Pixel(-30, -30),
      });
      map.add(marker);
    })
    .catch((e) => {
      console.log(e);
    });
});

onUnmounted(() => {
  map?.destroy();
});
</script>

<template>
  <div id="container"></div>
  <div class="mask">
    <img src="../assets/avatar.png" class="avatar" alt="avatar"/>
    <div class="mask-container">
      <img src="../assets/blur.png" class="blur" alt="blur"/>

      <div class="inner">
        <span class="txt">{{ txt }}</span>

        <div @click="openPop" class="btn">同意绑定</div>
      </div>
    </div>
  </div>

  <van-popup v-model:show="popShow" position="center" :close-on-click-overlay="false">
    <div class="pop-box">
      <img src="../assets/pop_bg.png" class="pop-bg" alt="pop-bg"/>

      <div class="pop-content">
        <img src="../assets/pop_title.png" class="pop-title" alt="pop-title"/>
        <img @click="downloadClick" src="../assets/pop_download.png" class="pop-download" alt="pop-download"/>
        <img @click="openAppClick" src="../assets/pop_open_app.png" class="pop-open-app" alt="pop-open-app"/>
        <img @click="closePop" src="../assets/pop_close.png" class="pop-close" alt="pop-close"/>
      </div>
    </div>
  </van-popup>
</template>

<style scoped>
@font-face {
  font-family: "ali";
  src: url("../assets/fy.ttf");
}

#container {
  width: 100vw;
  height: 100vh;
}

.mask {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  z-index: 200;
  display: flex;
  place-items: center;
  place-content: center;
  flex-direction: column;
}

.avatar {
  width: 20vw;
  height: 20vw;
  border-radius: 50%;
  border: 1px solid red;
  z-index: 201;
}

.mask-container {
  width: 100vw;
  background-image: linear-gradient(to bottom, #FF5C8A, #F6F6F6);
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  margin-top: -10vw;
  display: flex;
  place-items: center;
  place-content: center;
  box-sizing: border-box;
  padding: 5vw;
  padding-top: 15vw;
}

.blur {
  width: 90vw;
}

.inner {
  position: absolute;
  display: flex;
  place-items: center;
  place-content: center;
  flex-direction: column;
}

.txt {
  font-family: 'ali', serif;
  font-size: 18px;
  white-space: pre;
  text-align: center;
  line-height: 25px;
}


.btn {
  background-image: linear-gradient(143deg, #FF5C8A 0%, #652E38 100%);
  border-radius: 100px;
  width: 75vw;
  height: 12vw;
  margin: 0 auto;
  display: flex;
  place-items: center;
  place-content: center;
  color: white;
  margin-top: 4vw;
}

.van-popup {
  background: none;
}

.pop-box {
  position: relative;
  display: flex;
  place-items: center;
  place-content: center;
}

.pop-bg {
  width: 85vw;
}

.pop-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 85vw;
  height: 70vw;
  display: flex;
  place-items: center;
  place-content: center;
  flex-direction: column;
}

.pop-close {
  width: 10vw;
  position: absolute;
  right: 0;
  top: 0;
  padding: 5vw;
}


.pop-title {
  width: 60vw;
  margin-top: 10vw;
}

.pop-download {
  width: 70vw;
  padding-top: 10vw;
}

.pop-open-app {
  width: 40vw;
  padding: 5vw;
}
</style>
